import Axios, { AxiosResponse } from 'axios';
import { config } from '../../../config';

// eslint-disable-next-line import/prefer-default-export
export const postMail = async (
  entryId: string,
  name: string,
  email: string,
  phone: string,
  message: string,
) => {
  const { data }: AxiosResponse = await Axios.get(`${config.apiUrl}/news/listing`, {
    params: {
      entryId,
      name,
      email,
      phone,
      message,
    },
  });

  return data;
};
